import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import { keyboardMatches, keyboardKeys } from '@hh.ru/magritte-common-keyboard';
import { useMultipleRefs } from '@hh.ru/magritte-common-use-multiple-refs';
import { BottomSheet } from '@hh.ru/magritte-ui-bottom-sheet';
import { Drop } from '@hh.ru/magritte-ui-drop';
import { VSpacing } from '@hh.ru/magritte-ui-spacing';

const ActionList = ({ children, dropProps, bottomSheetProps, visible, ...commonProps }) => {
    const closedByKeyboardRef = useRef(false);
    const dropRef = useRef(null);
    const dropRefCallback = useMultipleRefs(dropRef, dropProps.ref);
    useEffect(() => {
        if (!visible) {
            if (closedByKeyboardRef.current && dropProps.activatorRef.current !== null) {
                dropProps.activatorRef.current.focus();
            }
            closedByKeyboardRef.current = false;
        }
    }, [dropProps.activatorRef, visible]);
    return (jsxs(Fragment, { children: [jsx(Drop, { ...dropProps, ...commonProps, autoFocusWhenOpened: true, keyboardNavigationMode: "list", onKeyDownCapture: (event) => {
                    if (keyboardMatches(event.nativeEvent, [
                        keyboardKeys.Enter,
                        keyboardKeys.Escape,
                        keyboardKeys.Space,
                    ])) {
                        closedByKeyboardRef.current = true;
                    }
                }, ref: dropRefCallback, space: 400, visible: visible, children: children }), jsxs(BottomSheet, { ...bottomSheetProps, ...commonProps, height: "content", visible: visible, children: [children, jsx(VSpacing, { default: 16 })] })] }));
};
ActionList.displayName = 'ActionList';

export { ActionList };
//# sourceMappingURL=ActionList.js.map
